import React from "react";

const FlashCircle = () => (
  <svg
    width="1.33rem"
    height="1.33rem"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5124 20.1198C16.384 20.1198 20.3333 16.1705 20.3333 11.2989C20.3333 6.42718 16.384 2.47791 11.5124 2.47791C6.64068 2.47791 2.69141 6.42718 2.69141 11.2989C2.69141 16.1705 6.64068 20.1198 11.5124 20.1198Z"
      stroke="#7E858F"
      strokeWidth="1.41135"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.58378 11.2194L10.0392 11.5811L9.20126 14.9684C9.0072 15.7623 9.3953 16.0268 10.0657 15.5593L14.635 12.3926C15.1907 12.0045 15.1113 11.5546 14.4497 11.387L12.9943 11.0254L13.8323 7.63814C14.0263 6.84425 13.6382 6.57964 12.9678 7.04715L8.39855 10.2139C7.84283 10.602 7.92221 11.0518 8.58378 11.2194Z"
      stroke="#7E858F"
      strokeWidth="1.41135"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FlashCircle;
